export function initYstMobileBehaviors() {
    if (typeof document === "undefined")
        return;
    const blockMultiTouch = (e) => {
        if (e.touches && e.touches.length > 1)
            e.preventDefault();
    };
    document.addEventListener("touchstart", blockMultiTouch, { passive: false });
    document.addEventListener("gesturestart", (e) => e.preventDefault());
}
